import { styled } from "../../../../styles/stitches.config"

export const InputSetContainer = styled("div", {
  display: "flex",
  flexDirection: "column",

  "@sm": {
    flexDirection: "row",
  },
})
